// images @ ui/src/components/static/
// files @ ui/public/

import React, { Component } from 'react'
import './home.css'

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('./static', false));
//console.log('images:', images)


class HomeEN extends Component {
  constructor(props) {
    super(props)
    this.topFunction = this.topFunction.bind(this);
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {
    //console.log('images: ', images)
    return (
      <section className="mx-5" style={{ maxWidth: "100%" }} >
        <p id="FSV Usage" className="title is-6"><span style={{fontSize: "24px", color: 'red'}}>FiveStar Vocab<sup>TM</sup>:</span> The Smartest Way to Activate Your Vocabulary</p>
        <p style={{ color: 'blue' }}> FiveStar Vocab and SpellingBee (SB) are functionally complementary tools designed to activate your vocabulary. While FiveStar Vocab builds connections between images and words to enhance reading comprehension, SB focuses specifically on listening comprehension.</p>
        <br></br>

        <p><b>1. FiveStar Vocab [1] </b>is a patent-pending method for mastering English vocabulary. To maximize deep comprehension through a high-efficiency learning path, each word is broken down into five core components. </p>
        <br></br>
        <p>The featured COEI segment (Characteristics or Essential Information) helps learners achieve deep comprehension. By creating a 'scaffolded' retrieval path [2], it empowers students—particularly ESL learners and beginners—to successfully recall words even after long intervals.</p>
        <img src={images['five-star-word-w-5com.png']} width="285" height="196" alt="five-star-figure" 
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <br></br>

        <p id="FSV ref" className="title is-6">2: The Science Behind the Method: Why it Works</p> 
        <p>1) Our brains have three memory areas.</p>
        <p><b>Sensory Memory:</b> For initial exposure.</p>
        <p><b>Working Memory:</b> For active rehearsal and encoding.</p>
        <p><b>Long-Term Memory:</b> For active, lasting knowledge.</p>
        <img src={images['3-vocab-mem-areas.png']} alt="3-vocab-mem-areas" />
        <p>Note that long-term memory is not permanent, if you do not use them for a long time, or if words are rote-memorized in isolation, your brain will eventually remove them to make space for important things.</p>
        <br></br>

        <p>2) Easy learning vs desirable difficulties learning [4] </p>
        <p>Unlike "easy learning" (such as massed practice), which feels productive initially but fails to build lasting knowledge, FiveStar Vocab utilizes desirable difficulties (DDs). While DDs may feel like more work at first, they create superior long-term performance and permanent retention.</p>
        <br></br>

        <p>3) desirable difficulties learning vs simple learning demo (source: 长沙一家人--捡瓶子比赛)</p>
        <video width="263" height="394" controls >
        <source src="./videos/bottle-collect-demo-1min.mp4" type="video/mp4"/>
        </video>
        <br></br> <br></br><br></br>

        <p id="FSV ref" className="title is-6">3. The Scaffolded Serial Books and Customized Services</p> 
        <p>The "Scaffolded" serial books are specifically designed for ESL students and beginners to master English vocabulary by using the FiveStar Vocab style.</p>
        <p>Attached is a demo vocabulary handbook:
          <a href="The-Scaffolded-English-Vocabulary-Handbook(demo).pdf" target="_blank" rel="noopener noreferrer"> <u>The-Scaffolded-English-Vocabulary-Handbook(demo)</u>
          </a>        
        </p><br></br>

        <p>To check the publish and upcoming books, please check our bookstore: </p>
        <a href="/bookstore" target="_blank"><u>Bookstore updated info</u></a>
        <br></br> <br></br>

        <p><b>Customized Services and Contacts</b></p>
        <p>If you have a specialized vocabulary list or any another language you wish to adapt into the FiveStar Vocab
        style book, or you need like to order the upcoming books, please click "Email Contact" at the bottom, and we are happy to help you.</p>
        <br></br>

        <p id="FSV ref" className="title is-6">4. Key references</p> 
        <p>[1] 
          <a href="./FiveStar Vocab: The Smartest Way to Activate Your Vocabulary.pdf" target="_blank" rel="noopener noreferrer"> <u>FiveStar Vocab: The Smartest Way to Activate Your Vocabulary</u>
          </a>
        </p>
        <p>[2] Lev Vygotsky, Zone of Proximal Development (ZPD) and Scaffolding, 1930s</p>
        <p>[3] Nation, I. S. P., Learning Vocabulary in Another Language, Cambridge University Press, 2013</p>
        <p>[4] Bjork, E. L., & Bjork, R. A., Introducing desirable difficulties into practice and instruction: Obstacles and opportunities, 2023
        </p>
        <br></br>

      </section>
    )
  }
}

export default HomeEN